import React from "react";
import { List as SemanticList } from "semantic-ui-react";
import "./HuiList.scss";
import PropTypes from "prop-types";

export const HuiList = ({
  avatarSize,
  headerType = "body-short-02",
  ...props
}) => {
  return (
    <div className={`hireart-ds-list ${headerType}`}>
      <SemanticList divided verticalAlign="middle" {...props} />
    </div>
  );
};

HuiList.propTypes = {
  headerType: PropTypes.oneOf([
    "prod-hd-02",
    "prod-hd-01",
    "body-short-02",
    "body-short-01",
  ]),
};

